<script setup lang="ts">
import { computed } from 'vue'
import type { PersonnelStatus } from '@/types'

const props = defineProps<{
  status: PersonnelStatus
}>()

const badgeClass = computed(() => {
  switch (props.status) {
    case 'available':      return 'bg-green-50 border-green-300 text-green-700'
    case 'assigned':       return 'bg-blue-50 border-blue-300 text-blue-700'
    case 'out-of-service': return 'bg-surface-container border-border text-outline'
    default:               return 'bg-surface-container border-border text-outline'
  }
})

const label = computed(() => {
  switch (props.status) {
    case 'available':      return 'Available'
    case 'assigned':       return 'Assigned'
    case 'out-of-service': return 'Out of Service'
    default:               return props.status
  }
})
</script>

<template>
  <span
    :class="[badgeClass, 'inline-flex items-center px-2 py-0.5 rounded font-mono text-xs uppercase tracking-wide border']"
  >
    {{ label }}
  </span>
</template>
